import React from "react"
import { 
  Button, 
  ButtonGroup,
  ControlLabel, 
  FormControl, 
  FormGroup, 
  Checkbox,
  Glyphicon, 
  InputGroup, 
  Well } from "react-bootstrap"


export default function FilterSidebar(props) {
  // PROPS
  const { 
    sortTrainingsBy,
    handleSortTrainingsBy,
    trainingFilters,
    handleFilterChange,
    handleSearchSubmit
  } = props


  // RENDER
  return (
    <div id="QMS-Filters-Sidebar">
      <Well>
        <center>
          <h3 style={{ marginTop: "0px" }}>View</h3>
        </center>
        <center>
          <ButtonGroup className="my-trainings-filter-buttons">
            <Button
              active={trainingFilters.showMyTrainings}
              onClick={() => handleFilterChange('showMyTrainings', true)}
            >
              My Trainings
            </Button>
            <Button
              active={!trainingFilters.showMyTrainings}
              onClick={() => handleFilterChange('showMyTrainings', false)}
            >
              All Trainings
            </Button>
          </ButtonGroup>
        </center>
  
        <center>
          <h3>Sort by</h3>
          <FormControl
              componentClass="select"
              placeholder="Sort Trainings"
              value={sortTrainingsBy}
              onChange={(e) => handleSortTrainingsBy(e.target.value)}
          >
            <option value="due_date">Due Date (most urgent)</option>
            <option value="name">Training Name</option>
          </FormControl>
        </center>
  
        <hr />
  
        <center>
          <h3>Filters</h3>
        </center>
        <FormGroup>
          <ControlLabel>Search by Training Name:</ControlLabel>
          <InputGroup>
            <FormControl
              type="text"
              value={ trainingFilters.searchTerm }
              onChange={ (e) => handleFilterChange('searchTerm', e.target.value) }
              onKeyDown={ (e) => e.key === 'Enter' ? handleSearchSubmit() : null }
            />
            <InputGroup.Button>
              <Button
                bsStyle="default"
                onClick={ handleSearchSubmit }
              >
                <Glyphicon glyph="search" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
  
        <FormGroup>
          <Checkbox
            checked={trainingFilters.notCompleted}
            onChange={() => handleFilterChange('notCompleted', !trainingFilters.notCompleted)}
          >
            Not Completed
          </Checkbox>
          <Checkbox
            checked={trainingFilters.pastDue}
            onChange={() => handleFilterChange('pastDue', !trainingFilters.pastDue)}
          >
            Past Due
          </Checkbox>
        </FormGroup>
      </Well>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Trainings/FilterSidebar.js